import { Check, LockKeyhole } from 'lucide-react';
import { Link } from 'react-router-dom';

const STEPS = [
  { key: 'pack', label: 'Pack order' },
  { key: 'label', label: 'Label & submit' },
  { key: 'handoff', label: 'Rider handoff' },
];

export function fulfillmentStepStates(order) {
  const packed = ['PACKED', 'READY_FOR_DISPATCH'].includes(order?.fulfillmentStatus);
  // Ready means the label is confirmed on the parcel AND the system decided it
  // can go. A stored READY verdict alone is not enough: one decided before the
  // attachment rule existed, or before a replacement, must not unlock the handoff.
  const ready = order?.readiness?.status === 'READY'
    && (Number(order?.workflowVersion) !== 2 || Boolean(order?.parcelLabel?.attachedAt));
  const handedOff = order?.delivery?.assignmentStatus === 'PICKED_UP' || order?.stage === 'DELIVERY';
  return {
    pack: packed ? 'complete' : 'current',
    label: ready ? 'complete' : packed ? 'current' : 'locked',
    handoff: handedOff ? 'complete' : ready ? 'current' : 'locked',
  };
}

export function earliestFulfillmentStep(order) {
  const states = fulfillmentStepStates(order);
  return STEPS.find(step => states[step.key] === 'current')?.key || 'handoff';
}

export function canOpenFulfillmentStep(order, step) {
  const state = fulfillmentStepStates(order)[step];
  return state === 'current' || state === 'complete';
}

export default function WorkflowStageRail({ order, currentStep, query = '' }) {
  const states = fulfillmentStepStates(order);
  return <ol aria-label="Fulfillment workflow" className="grid gap-2 sm:grid-cols-3">
    {STEPS.map((step, index) => {
      const state = states[step.key];
      const current = currentStep === step.key;
      const complete = state === 'complete';
      const classes = `flex min-h-14 items-center gap-2 rounded-xl border px-3 py-2 text-sm font-semibold ${current
        ? 'border-accent bg-accent-subtle text-accent'
        : complete
          ? 'border-success bg-success-subtle text-success'
          : 'border-neutral-200 bg-neutral-50 text-neutral-500 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-400'}`;
      const content = <><span className={`grid h-7 w-7 shrink-0 place-items-center rounded-full ${current ? 'bg-accent text-on-accent' : complete ? 'bg-success-subtle text-success' : 'bg-neutral-200 dark:bg-neutral-800'}`}>{complete ? <Check className="h-4 w-4" aria-hidden="true" /> : state === 'locked' ? <LockKeyhole className="h-3.5 w-3.5" aria-hidden="true" /> : index + 1}</span><span>{step.label}</span></>;
      return <li key={step.key}>{state === 'locked' ? <div className={classes}>{content}</div> : <Link aria-current={current ? 'step' : undefined} to={`/business/orders/fulfillment/${order.orderId}/${step.key}${query ? `?${query}` : ''}`} className={`${classes} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus`}>{content}</Link>}</li>;
    })}
  </ol>;
}
